// React
import { useEffect, useState, useRef } from "react";

// Libraries
import moment from "moment";

const useClock = (timestamp, endTimestamp = null) => {
	const intervalRef = useRef(null);
	const [clockTime, setClockTime] = useState(0);

	useEffect(() => {
		if (endTimestamp !== null) {
			const newTime = Math.floor(moment.duration(moment(endTimestamp).diff(moment(timestamp))).asSeconds());
			setClockTime(newTime);
		} else {
			intervalRef.current = setInterval(() => {
				const newTime = Math.floor(moment.duration(moment().diff(moment(timestamp))).asSeconds());
				setClockTime(newTime);
			}, 1000);
		}

		return () => {
			clearInterval(intervalRef.current);
		};
	}, [timestamp, endTimestamp]);

	return clockTime;
};

export default useClock;
